

import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";

export class WeaponMasteryProperty extends DandDFeatureSource {
  data_type: DataType = "weapon_mastery_property";
  feature_source_type = "WeaponMasteryProperty";
  required_weapon_keyword_ids: string[] = [];
  required_weapon_keyword_ids2: string[] = [];

  constructor(obj?: any) {
    super(obj, "WeaponMasteryProperty");
    if (obj) {
      this.required_weapon_keyword_ids = obj.required_weapon_keyword_ids ? obj.required_weapon_keyword_ids : [];
      this.required_weapon_keyword_ids2 = obj.required_weapon_keyword_ids2 ? obj.required_weapon_keyword_ids2 : [];
    }
    // this.loaded = true;
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      required_weapon_keyword_ids: this.required_weapon_keyword_ids,
      required_weapon_keyword_ids2: this.required_weapon_keyword_ids2
    };
  }

  toLight(): any {
    const feature_source_obj = super.toLight();
    return {
      ...feature_source_obj,
      required_weapon_keyword_ids: this.required_weapon_keyword_ids,
      required_weapon_keyword_ids2: this.required_weapon_keyword_ids2
    };
  }

  copy(copyMe: WeaponMasteryProperty, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.required_weapon_keyword_ids = [...copyMe.required_weapon_keyword_ids];
    this.required_weapon_keyword_ids2 = [...copyMe.required_weapon_keyword_ids2];
  }

  clone(drop_ids = false): WeaponMasteryProperty {
    const new_obj = new WeaponMasteryProperty();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}